<script>
import ChangePasswordForm from "@/components/common/ChangePasswordForm.vue";

export default{
  components: {ChangePasswordForm},
  props:['dialog'],
  data(){
    return {
      form_data:{theme_name:'theme_default',layout:'layout_tlr',main_page:'/back/map'},
      rules:{},
      current_user:{},
      change_dialog:{show:false,title:'修改密码'}
    }
  },
  methods:{
    fun_submit(){
      localStorage.setItem('theme_name',this.form_data.theme_name);
      localStorage.setItem('layout',this.form_data.layout);
      localStorage.setItem('main_page',this.form_data.main_page);
      Object.assign(this.dialog,{show:false});
      location.reload();
    },
    fun_open_change(){
      this.change_dialog.show=true;
    },
    async logout() {
      await this.$store.dispatch('logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      location.reload()
    },
    fun_close(){
      this.dialog.show=false;
    },
  },
  mounted() {
    const theme_name = localStorage.getItem('theme_name');
    const layout = localStorage.getItem('layout');
    const main_page = localStorage.getItem('main_page');
    if(theme_name) this.form_data.theme_name = theme_name;
    if(layout) this.form_data.layout = layout;
    if(main_page) this.form_data.main_page = main_page;
    this.current_user = this.$store.state.user;
  }
}
</script>

<template>
  <el-drawer title="设置参数"
    :visible.sync="dialog.show" :withHeader="false"
    :before-close="fun_close" size="350px">
  <div class="comp_setting" v-show="dialog.show">
    <el-form :model="form_data" :rules="rules" ref="form_customer" size="small">
      <el-form-item label="选择主题" prop="theme_name">
        <el-select v-model="form_data.theme_name" style="width: 100%;">
          <el-option value="theme_default" label="默认"></el-option>
          <el-option value="theme_blue" label="蓝色"></el-option>
          <el-option value="theme_red" label="红色"></el-option>
          <el-option value="theme_dark" label="深色"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="首页" prop="main_page">
        <el-select v-model="form_data.main_page" style="width: 100%;">
          <el-option value="/back/dashboard" label="空白页"></el-option>
          <el-option value="/back/analysis/tree_map" label="统计图表"></el-option>
          <el-option value="/back/weigh/monitor" label="过磅监控"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="菜单布局" prop="layout">
        <el-select v-model="form_data.layout" style="width: 100%;">
          <el-option value="layout_tb" label="顶部"></el-option>
          <el-option value="layout_tlr" label="左侧"></el-option>
        </el-select>
      </el-form-item>
      <br/>
      <el-form-item label="">
        <el-button plain type="primary" icon="el-icon-check" @click="fun_submit" style="width:100%;">确认设置</el-button>
      </el-form-item>
      <el-divider></el-divider>
      <div style="text-align: center;">
        <el-link type="primary" icon="el-icon-edit" @click="fun_open_change" style="margin-left:10px;">修改密码</el-link>
        <el-link type="danger" icon="el-icon-switch-button" @click="logout" style="margin-left:10px;">退出登录</el-link>
      </div>
    </el-form>
  </div>
    <ChangePasswordForm v-if="change_dialog.show" :dialog="change_dialog"></ChangePasswordForm>
  </el-drawer>
</template>

<style>
.comp_setting{padding:30px;}
</style>